import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const localBudgetService = {
  getAll,
  search,
  deleteLocalBudget
};

const requestOptions = {
  method: 'GET',
  headers: Object.assign(
    {},
    {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  )
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/local_budgets/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function search(searchLocalBudget, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/local_budgets/search?title=${
    searchLocalBudget.title
  }&archiveYear=${searchLocalBudget.archiveYear}&page[number]=${
    pageNumber ? pageNumber : 1
  }`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}

function deleteLocalBudget(localBudgetId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/local_budgets/${localBudgetId}`;

  return axios.delete(url, requestOptionsDelete);
}
